// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"04d76687","453":"b5fa1687","455":"34f32ede","977":"d0d66f10"}[chunkId] + ".chunk.js";
};